import React, { useState, useRef, useEffect } from "react";
import { Bell, ChevronDown, CircleHelp, Menu } from "lucide-react";
import ProfileModal from "./ProfileModal";
import HelpModal from "./HelpModal";
import NotificationModal from "./NotificationModal";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../Common/CustomButton";
import CreateRoles from "../../Pages/IAM/Roles/CreateRoles";
import AddServiceModal from "../../Pages/General/Services/AddServiceModal";
import { useSelector,useDispatch } from "react-redux";
import { toggleEditForm } from "../../redux/locations/locationSlice";
import { toggleFormState } from "../../redux/service/serviceSlice";
const PAGE_TITLES = {
  "/dashboard": "Dashboard",
  "/providers/locations": "Locations",
  "/providers/ward": "Wards",
  "/general/services": "Services",
  "/general/pharmacy": "Pharmacy",
  "/general/add-pharmacy": "Add pharmacy",
  "/general/diagnostic": "Diagnostics",
  "/general/add-diagnostic": "Add diagnostic",
  "/general/package": "Packages",
  "/general/add-package": "Add package",
  "/patients": "Patients",
  "/apps/practitioner/roster": "Doctor roster",
  "/billing": "Billing",
  "/opd": "OPD · Appointments",
  "/ipd": "IPD · Inpatients",
  "/prescriptions": "Prescriptions",
  "/iam/users": "Staff & doctors",
  "/iam/roles": "Roles",
  "/partners/agreement": "Partner agreements",
  "/notification": "Notifications",
};

const titleFor = (pathname) => {
  const key = Object.keys(PAGE_TITLES).find((k) => k.toLowerCase() === pathname.toLowerCase());
  if (key) return PAGE_TITLES[key];
  const last = pathname.split("/").filter(Boolean).pop() || "dashboard";
  return last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, " ");
};

const Topbar = ({ toggleCreateProviderForm, showForm ,onMenuClick}) => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [isCreateRolesModalOpen, setIsCreateRolesModalOpen] = useState(false);
 
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { editForm } = useSelector((state) => state.locations);
   const{profileData} = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const thanosRef = useRef();
  const handleClickOutside = (event) => {
    if (thanosRef.current && !thanosRef.current.contains(event.target)) {
      setIsNotificationModalOpen(false);
      setIsHelpModalOpen(false);
      setIsProfileModalOpen(false);
   
    }
  };

  const handleLocationclick = () => {
    navigate("/providers/locations");
    toggleCreateProviderForm();
  };

  const handleDiagnosticlick = () => {
    navigate(`/general/add-diagnostic`);
    toggleCreateProviderForm();
  };

  const handleUsersBackClick = () => {
    navigate("/iam/users");
    toggleCreateProviderForm();
  };
  const handlePackageBackClick = () => {
    navigate("/general/add-package");
  };
  const handlePharmacyBackClick = () => {
    navigate("/general/add-pharmacy");
    toggleCreateProviderForm();
  };

  const handleRolesClick = () => {
    setIsCreateRolesModalOpen(true);
    toggleCreateProviderForm(false);
  };
  const handleServicesClick = () => {
    dispatch(toggleFormState());
  };

  useEffect(() => {
 
    if (isNotificationModalOpen || isHelpModalOpen || isProfileModalOpen ) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const pathSegments = pathname.split("/").filter((x) => x);

  const handleProfileClick = () => {
    setIsProfileModalOpen(() => !isProfileModalOpen);
    setIsHelpModalOpen(() => false);
    setIsNotificationModalOpen(() => false);
  };

  const handleHelpClick = () => {
    setIsHelpModalOpen(() => !isHelpModalOpen);
    setIsProfileModalOpen(() => false);
    setIsNotificationModalOpen(() => false);
  };

  const handleNotificationClick = () => {
    setIsNotificationModalOpen(() => !isNotificationModalOpen);
    setIsProfileModalOpen(() => false);
    setIsHelpModalOpen(() => false);
  };

  const fullName = [profileData?.firstName, profileData?.lastName].filter(Boolean).join(" ");
  const initials = `${profileData?.firstName?.[0] || ""}${profileData?.lastName?.[0] || ""}`.toUpperCase();

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center justify-between gap-4 border-b border-slate-200 bg-white/90 px-4 backdrop-blur sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button onClick={onMenuClick} className="rounded-md p-1.5 text-slate-600 hover:bg-slate-100 lg:hidden" aria-label="Open menu">
          <Menu className="h-5 w-5" />
        </button>
        <div className="min-w-0">
          <h1 className="truncate text-base font-semibold text-slate-900">{titleFor(pathname)}</h1>
          <p className="hidden truncate text-xs text-slate-500 sm:block">
            Hospital admin
            {pathSegments.map((segment) => (
              <span key={segment}>
                <span className="mx-1.5 text-slate-300">/</span>
                <span className="capitalize">{segment === "iam" ? "IAM" : segment.replace(/-/g, " ")}</span>
              </span>
            ))}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="mr-2 flex items-center gap-2">
          {window.location.href.includes("locations") && !showForm&&(
            <CustomButton
              text={ "Locations +" }
              onClick={handleLocationclick}
            ></CustomButton>
          )}
          {window.location.href.includes("diagnostic") && !showForm&&(
            <CustomButton
              text={ "Diagnostic +" }
              onClick={handleDiagnosticlick}
            ></CustomButton>
          )}
          {/* {window.location.href.includes("organizations") && !showForm && (
            <CustomButton
              text={"Organizations +"}
              onclick={toggleCreateProviderForm}
            ></CustomButton>
          )} */}
          {window.location.href.includes("circle") && !showForm && (
            <CustomButton
              text={"Patient Circle +"}
              onClick={toggleCreateProviderForm}
            ></CustomButton>
          )}
               {window.location.href.includes("package") && (
             <CustomButton text="Package +" onClick={handlePackageBackClick} />
           )}
               {window.location.href.includes("pharmacy") &&!showForm &&  (
             <CustomButton text="Add Pharmacy +" onClick={handlePharmacyBackClick} />
           )}
             {window.location.href.includes("services") && (
        <CustomButton text="Add Service +" onClick={handleServicesClick} />
      )}
          {window.location.href.includes("user") &&  !showForm &&(
            <CustomButton
              text={ "User +"}
              onClick={handleUsersBackClick}
            ></CustomButton>
          )}

          {window.location.href.includes("roles") &&  (
            <CustomButton text="Roles +" onClick={handleRolesClick} />
          )}

          {isCreateRolesModalOpen && (
            <CreateRoles
              showForm={isCreateRolesModalOpen}
              setShowForm={setIsCreateRolesModalOpen}
            />
          )}
        </div>
        <div className="relative" ref={thanosRef}>
          <button onClick={handleHelpClick} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-700" aria-label="Help">
            <CircleHelp className="h-5 w-5" />
          </button>
          {isHelpModalOpen && <HelpModal />}
        </div>
        <div className="relative" ref={thanosRef}>
          <button onClick={handleNotificationClick} className="relative rounded-lg p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-700" aria-label="Notifications">
            <Bell className="h-5 w-5" />
            <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-rose-500 ring-2 ring-white" />
          </button>
          {isNotificationModalOpen && <NotificationModal />}
        </div>
        <div className="relative ml-1" ref={thanosRef}>
          <button onClick={handleProfileClick} className="flex items-center gap-2.5 rounded-lg py-1 pl-1 pr-2 hover:bg-slate-100">
            {profileData?.imageUrl ? (
              <img src={profileData.imageUrl} alt="" className="h-8 w-8 rounded-full object-cover" />
            ) : (
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-100 text-xs font-semibold text-brand-700">{initials || "A"}</span>
            )}
            <span className="hidden text-left leading-tight md:block">
              <span className="block text-sm font-medium text-slate-900">{fullName || "Admin"}</span>
              <span className="block text-xs text-slate-500">Hospital administrator</span>
            </span>
            <ChevronDown className="hidden h-4 w-4 text-slate-400 md:block" />
          </button>
          {isProfileModalOpen && <ProfileModal />}
        </div>
      </div>
    </header>
  );
};

export default Topbar;
